module.exports = __webpack_public_path__ + "img/Connecticut Outline.5df813fd.png";